"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _colors = require("../../../colors");
var Theme = {
  "default": {
    backgroundColor: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.GREY_600,
    color: _colors.FullPalette.EVERGREEN_700,
    labelColor: _colors.FullPalette.GREY_900,
    requiredColor: _colors.FullPalette.POPPY_600,
    placeholder: _colors.FullPalette.GREY_900
  },
  focused: {
    borderBottomColor: _colors.FullPalette.GREEN_700,
    color: _colors.FullPalette.GREY_900
  },
  error: {
    borderColor: _colors.FullPalette.POPPY_600,
    color: _colors.FullPalette.POPPY_600
  },
  disabled: {
    backgroundColor: _colors.FullPalette.GREY_E500,
    labelColor: _colors.FullPalette.GREY_800
  },
  readOnly: {
    backgroundColor: _colors.FullPalette.GREY_E500
  }
};
var _default = exports["default"] = Theme;